export default [
  {
    name: 'quote',
    permissionKey: 'quote_management',
    label: 'labels.quoteManagement',
    children: [
      {
        name: 'quote_add',
        label: 'labels.quoteAdd',
        permissionKey: 'quote_add'
      },
      {
        name: 'quote_edit',
        label: 'labels.quoteEdit',
        permissionKey: 'quote_edit'
      },
      {
        name: 'quote_view_detail',
        label: 'labels.quoteViewDetail',
        permissionKey: 'quote_view_detail'
      },
      {
        name: 'quote_view_detail_quote_internal',
        label: 'labels.quoteInternalViewDetail',
        permissionKey: 'quote_view_detail_quote_internal'
      },
      {
        name: 'quote_price_information',
        label: 'labels.viewQuotePriceInformation',
        permissionKey: 'quote_price_information'
      },
      {
        name: 'quote_delete',
        label: 'labels.quoteDelete',
        permissionKey: 'quote_delete'
      },
      {
        name: 'quote_archive',
        label: 'labels.quoteArchive',
        permissionKey: 'quote_archive'
      },
      // {
      //   name: 'quote_restore',
      //   label: 'labels.quoteRestore',
      //   permissionKey: 'quote_restore'
      // },
      {
        name: 'quote_request',
        label: 'labels.quoteRequestManagement',
        permissionKey: 'quote_request_management',
        children: [
          {
            name: 'quote_request_add',
            label: 'labels.quoteRequestAdd',
            permissionKey: 'quote_request_add'
          },
          {
            name: 'quote_request_edit',
            label: 'labels.quoteRequestEdit',
            permissionKey: 'quote_request_edit'
          },
          {
            name: 'quote_view_detail_quote_request',
            label: 'labels.quoteRequestViewDetail',
            permissionKey: 'quote_view_detail_quote_request'
          },
          {
            name: 'quote_request_delete',
            label: 'labels.quoteRequestDelete',
            permissionKey: 'quote_request_delete'
          },
          {
            name: 'quote_request_activity',
            label: 'labels.viewQuoteRequestActivity',
            permissionKey: 'quote_request_activity'
          },
          {
            name: 'quote_request_archive',
            label: 'labels.quoteRequestArchive',
            permissionKey: 'quote_request_archive'
          }
          // {
          //   name: 'quote_request_restore',
          //   label: 'labels.quoteRequestRestore',
          //   permissionKey: 'quote_request_restore'
          // }
        ]
      }
    ]
  }
]
